import { BREAKPOINT_M } from '@audi/audi-ui-design-tokens';
import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { zIndexFront } from '~/styles/tokens';

export const TacticalContainer = styled.div`
	cursor: default;

	.--trigger-container {
		height: ${SYS_SPACE_FIXED_300};

		#incentives-popover {
			@media (max-width: ${BREAKPOINT_M}px) {
				width: auto;
			}
		}
	}
	.--content-container {
		max-height: 420px;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		padding: 2px;

		.--tactical-card {
			margin-bottom: 1rem;
			display: flex;
			gap: 0.8rem;
			width: 256px;

			.is-loading::after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(255, 255, 255, 0.9);
				z-index: ${zIndexFront};
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	#incentives-popover {
		z-index: 10;
	}
`;

export const TacticalsDialogContainer = styled.div`
	.--column-heading {
		width: max-content;
	}
`;
